module.exports = __webpack_public_path__ + "img/back-text.32b304b4.svg";